import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/feeSeller/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/feeSeller/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
  request.post('/api/v4ward/feeSeller/remove', qs.stringify(params),options);

export const add = (params, options) =>
  request.post('/api/v4ward/feeSeller/submit', params,options)

export const update = (params, options) =>
  request.post('/api/v4ward/feeSeller/submit', params,options)

export const sync = (params, options) =>
  request.post('/api/v4ward/feeSeller/sync', qs.stringify(params),options);

export const getSellerList = (params, options) =>
  request.get('/api/v4ward/feeSeller/selectFeeSellerList', Object.assign({}, options, { params }));

//获取销售方信息
export const getAllSellerList = (params, options) =>
  request.get('/api/v4ward/feeSeller/seller-list-all', Object.assign({}, options, { params }));
